<script>
import Modal from "./Modal";

export default { mixins: [Modal] };
</script>
